import React from "react";

import svg from "../../assets/images/icons/dropdown_blue.svg";

export const DropdownBlueIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Dropdown"}
    />
);
